import ApiService from "../../../common/api.service";

export async function GetReports({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("GET_REPORTS_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/order/list", option);
    commit("GET_REPORTS_SUCCESS", _response);
  } catch (error) {
    commit("GET_REPORTS_ERROR", { result: error.message });
  }
}

export async function ExportToExcelReport({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("GET_EXPORT_TO_EXCEL_REPORT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/order/list", option);
    window.open(_response.data.message)
    commit("GET_EXPORT_TO_EXCEL_REPORT_SUCCESS", _response);
  } catch (error) {
    commit("GET_EXPORT_TO_EXCEL_REPORT_ERROR", { result: error.message });
  }
}